import { render, staticRenderFns } from "./TicketsHistoryDetailsAccordion.vue?vue&type=template&id=b5a6f8e6&scoped=true"
import script from "./TicketsHistoryDetailsAccordion.vue?vue&type=script&lang=js"
export * from "./TicketsHistoryDetailsAccordion.vue?vue&type=script&lang=js"
import style0 from "./TicketsHistoryDetailsAccordion.vue?vue&type=style&index=0&id=b5a6f8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a6f8e6",
  null
  
)

export default component.exports